import * as z from "zod/v4";

export enum SingleOrderAuthError {
  INVALID_EMAIL_OR_ZIP = "INVALID_EMAIL_OR_ZIP",
  MUST_PROVIDE_EMAIL_OR_ZIP = "MUST_PROVIDE_EMAIL_OR_ZIP",
}

export enum SingleOrderAuthStatus {
  AUTHENTICATED = "authenticated",
  ORDER_SELECTION_REQUIRED = "order_selection_required",
}

const authenticatedSingleOrderAuthOutput = z.object({
  status: z.literal(SingleOrderAuthStatus.AUTHENTICATED),
  customerAuthToken: z.string(),
  customer: z
    .object({ name: z.string(), email: z.string(), customerId: z.string() })
    .nullish(),
  orderId: z.string(),
});

const orderSelectionRequiredSingleOrderAuthOutput = z.object({
  status: z.literal(SingleOrderAuthStatus.ORDER_SELECTION_REQUIRED),
  orders: z.array(z.object({ shopifyId: z.string(), orderName: z.string() })),
});

export const singleOrderAuth = {
  name: "singleOrderAuth" as const,
  input: z.object({
    emailOrZip: z.string(),
    orderIdTrackingNumber: z.string(),
  }),
  output: z.discriminatedUnion("status", [
    authenticatedSingleOrderAuthOutput,
    orderSelectionRequiredSingleOrderAuthOutput,
  ]),
};
